<!--
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2022-07-30 17:36:38
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-12-28 17:22:58
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/picc2212/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="picc2212">
    <div id="banner">
      <img
        @click="showRule"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-rule.png"
        class="rule"
        alt=""
      />
    </div>
    <div class="tab">
      <img
        class="tit"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-1.png"
        alt=""
      />
    </div>
    <div class="box">
      <div class="daojishi">
        <span class="days">{{ days }}</span>
      </div>
      <div class="both">
        <img
          @click="jumpFlight"
          v-maidian="'jumpFlight'"
          class="flight"
          src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-flight.png"
          alt=""
        />
        <img
          @click="jumpTrain"
          v-maidian="'jumpTrain'"
          class="flight"
          src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-train.png"
          alt=""
        />
      </div>
    </div>
    <img
      class="tit"
      src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-2.png"
      alt=""
    />
    <div class="swipe-wrapper">
      <mt-swipe :auto="0" ref="swipeWrapper">
        <mt-swipe-item v-for="(item, index) in imgList" :key="index">
          <div class="img-box">
            <div class="img">
              <img @click="jumpTo(index)" :src="item" alt="" />
            </div>
          </div>
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <img
      src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-6.png"
      class="tit tit2"
      alt=""
    />
    <div class="mastrybox clear">
      <img
        @click="lotteryFn"
        class="gift"
        v-for="(item, index) in gifts"
        :key="index"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-gift.png"
        alt=""
      />
    </div>
    <div class="submit">
      <p class="times">剩余抽奖机会：{{ setting.zs }}次</p>
      <img
        @click="getMoreTimes"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-5.png"
        class="getMore"
        alt=""
      />
      <a href="https://www.picc.com/" v-maidian="'gohome'" class="knowMore"
        >前往官网·了解更多</a
      >
    </div>
  </div>
</template>
<script>
import banner from './components/banner.vue';
import lineComp from './components/line.vue';
import loginDialog from './components/dialog/login/index';
import giftDialog from './components/dialog/gift/index';
import videoComp from './components/videoComp.vue';
import moreTimes from './components/dialog/moreTimes/index';
import moment from 'moment';
import ruleDialog from './components/dialog/rule/index';
export default {
  components: {
    banner,
    lineComp,
    videoComp,
  },
  data() {
    return {
      gifts: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      setting: {},
      days: 0,
      linkList:[
          'https://m.picc.com/wproduct/#/entryroute?productCode=EAK_0017',
          'https://mlife.picc.com/ebsweb/#/newfs_fusion?combCode=C71940&utmSource=234&utmType=1&platform=f&dataSource=SEM-WAP&JobNo=6111100001&eventsName=wap',
          'https://szgezhangtest.picchealth.com/mall/#/lifeSerious?source=2'
      ],
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-31.png',
        'https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-32.png',
        'https://source.qunarzz.com/site/images/wns/20221228-shijianchen-thumb.jpeg',
      ],
    };
  },
  mounted() {
    // moreTimes({});
    this.getChannelNum();
    let days = -moment().diff('2023/01/21', 'days');
    this.days = days;
    // giftDialog({
    //     giftType:'THANKS'
    // })
  },
  methods: {
    jumpTo(index) {
      window.location.href = this.linkList[index];
    },
    showRule: ruleDialog,
    getMoreTimes() {
      this.getChannelNum(() => {
        moreTimes({
          setting: this.setting,
          callback: this.addTimeBySource,
        });
      });
    },
    addTimeBySource(source, callback) {
      this.commonAjax({
        url: '/commonly/addTimeBySource?source=' + source,
        method: 'get',
        hideError: true,
        success: (data) => {
          this.getChannelNum(callback);
        },
      });
    },
    jumpFlight() {
      if (hysdk.sniff.scheme) {
        location.href =
          hysdk.sniff.scheme +
          `://flight/main?cat=globalSearch&isNotClosePre=1&module=search&submodule=roundway&depCity=%E5%8C%97%E4%BA%AC&arrCity=%E6%88%90%E9%83%BD&`;
      } else {
        location.href = 'https://m.flight.qunar.com/h5/flight/';
      }
    },
    jumpTrain() {
      if (hysdk.sniff.scheme) {
        location.href = hysdk.sniff.scheme + `://railway/main`;
      } else {
        location.href =
          'https://touch.train.qunar.com/train_touch/index.html#/?&bd_source=jinjiangjituan';
      }
    },
    commonAjax(config) {
      this.$axios[config.method || 'post'](config.url, config.data || {}).then(
        (res) => {
          if (res.code == 200) {
            config.success && config.success(res.data);
          } else if (res.code == 400) {
            if (config.hide == 'login') {
              return;
            }
            loginDialog({
              callback: () => {
                this.commonAjax(config);
              },
            });
          } else {
            !config.hideError &&
              this.$dialog.alert({
                message: res.message,
              });
          }
        },
      );
    },
    lotteryFn() {
      this.getChannelNum();
      this.commonAjax({
        url: '/commonly/lottery',
        method: 'post',
        success: (data) => {
          giftDialog({
            giftType: data.code,
            ext: data.ext,
            id: data.winRecordId,
          });
          this.getChannelNum();
        },
      });
    },
    getChannelNum(callback) {
      this.commonAjax({
        url: '/commonly/getChannelNum',
        method: 'get',
        hide: callback ? null : 'login',
        success: (data) => {
          this.setting = data;
          callback && callback(data);
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
#picc2212 {
  background: #f6372a
    url(https://source.qunarzz.com/site/images/wns/20221226-shijianchen-bg.jpg)
    no-repeat;
  background-size: 100% auto;
  min-height: 1792px;
  font-family: "fzmd-demibold";
}
#banner {
  height: 448px;
  position: relative;
  .rule {
    position: absolute;
    right: 10px;
    bottom: 0;
    width: 62px;
  }
}
.tit {
  width: calc(100% - 46px);
  margin: 20px auto 27px;
}
.tit2 {
  margin-bottom: 15px;
}
.box {
  width: calc(100% - 18px);
  margin: 0 auto;
}
.both {
  display: flex;
  padding: 10px;
  margin-top: 10px;
  background: #fff4ec;
  border-radius: 6px;
  justify-content: space-between;
}
.flight {
  width: 163px;
}
.daojishi {
  background: url(https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-daojishi2.png)
    no-repeat;
  background-size: 100% 100%;
  width: 355px;
  position: relative;
  height: 73px;
  .days {
    position: absolute;
    left: 163px;
    top: 0;
    width: 67px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 33px;
    font-family: FZLanTingHeiS-B-GB;
    font-weight: bold;
    font-style: italic;
    color: #f4413d;
    text-shadow: 0px 2px 2px rgba(132, 179, 195, 0.61);
    -webkit-text-stroke: 1px #ffe492;
    text-stroke: 1px #ffe492;
    font-family: 'fzmd-demibold';
    background: linear-gradient(
      96deg,
      #cb1419 0%,
      #f45746 81.0302734375%,
      #ff0d10 100%
    );
    -webkit-background-clip: text;
    justify-content: center;
  }
}
.swipe-wrapper {
  width: 355px;
  height: 240px;
  margin: 0 auto;
  /deep/ .mint-swipe-indicator {
    opacity: 1;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #ffc168;
    &.is-active {
      width: 46px;
      height: 5px;
      background: #ffc168;
      border-radius: 2px;
    }
  }
}
.img{
    height: 204px;
    overflow-y:hidden ;
}
.img img{
  width: 100%;
  height: 204px;
}
.mastrybox {
  width: 355px;
  height: 355px;
  background: url(https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-box.png)
    no-repeat;
  background-size: 100% auto;
  margin: 0 auto;
  padding: 20px 27px;
  box-sizing: border-box;
}
.gift {
  width: 77px;
  height: 84px;
  float: left;
  margin-right: 30px;
  margin-bottom: 15px;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
}
.getMore {
  height: 45px;
  margin-top: 8px;
  margin-bottom: 22px;
}
.times {
  font-family: FZMoDengTiS;
  font-weight: 600;
  color: #f2d2a0;
  font-size: 9px;
  margin-top: 12px;
}
.knowMore {
  font-size: 16px;
  font-family: FZMoDengTiS;
  font-weight: 600;
  color: #f2d2a0;
  display: block;
  text-decoration: underline;
  padding-bottom: 15px;
}
</style>